import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePosAuth } from '../context/PosAuthContext';

const PosPrivateRoute = ({ children }) => {
  const { isPosSeller, loading } = usePosAuth();
  const location = useLocation();

  if (loading) {
    return <div style={{ padding: '20px' }}>로딩중...</div>;
  }

  if (!isPosSeller) {
    return (
      <Navigate
        to="/pos/manage"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
};

export default PosPrivateRoute;